<template>
  <v-row justify="center">
    <v-snackbar
      v-model="snackState"
      :color="snackColor"
      :timeout="snackTime"
      bottom
      right
    >
      {{ snackText }}
    </v-snackbar>
    <v-dialog v-model="dialog" persistent max-width="350px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="pb-4">
            <span class="text-h5">Actualizar Contraseña</span>
          </v-card-title>
          <v-card-text class="pb-0">
            <v-container>
              <v-row>
                <v-col cols="12" class="my-0 py-0">
                  <v-text-field
                    v-model.trim="oldPassword"
                    label="Contraseña Anterior"
                    :append-icon="
                      showOldPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showOldPassword = !showOldPassword"
                    :type="showOldPassword ? 'text' : 'password'"
                    :rules="requiredRule"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="my-0 py-0">
                  <v-text-field
                    v-model.trim="newPassword"
                    label="Nueva Contraseña"
                    :append-icon="
                      showNewPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showNewPassword = !showNewPassword"
                    :type="showNewPassword ? 'text' : 'password'"
                    :rules="contraseñaRule"
                    required
                    outlined
                    dense
                  ></v-text-field> </v-col
                ><v-col cols="12" class="my-0 py-0">
                  <v-text-field
                    v-model.trim="reNewPassword"
                    label="Repetir Nueva Contraseña"
                    :rules="contraseñaRule"
                    :append-icon="
                      showReNewPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showReNewPassword = !showReNewPassword"
                    :type="showReNewPassword ? 'text' : 'password'"
                    required
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="px-6 pb-4">
            <v-btn
              color="blue darken-1"
              @click="UpdatePassword"
              :disabled="!valid"
              class="white--text"
              block
            >
              Actualizar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>


<script>
import Axios from "axios";

export default {
  name: "ChangePassword",
  data: () => ({
    dialog: false,
    valid: true,
    oldPassword: null,
    newPassword: null,
    reNewPassword: null,
    showOldPassword: false,
    showNewPassword: false,
    showReNewPassword: false,
    snackColor: "primary",
    snackState: false,
    snackText: "Sample",
    snackTime: 4500,
    contraseñaRule: [
      (v) => !!v || "Este campo es obligatorio",
      (v) => (v && v.length >= 6) || "Debe contener al menos 6 caracteres",
      (v) => /[A-Z]/.test(v) || "Debe contener al menos una letra mayúscula",
      (v) => /[0-9]/.test(v) || "Debe contener al menos un número",
      (v) =>
        /[!@#$%^&*(),.?":{}|<>]/.test(v) ||
        "Debe contener al menos un símbolo especial",
    ],
    requiredRule: [(v) => !!v || "Campo Requerido."],
  }),
  created() {
    this.CheckChange();
  },
  methods: {
    UpdatePassword() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      if (
        this.$refs.form.validate() &&
        this.newPassword == this.reNewPassword
      ) {
        Axios.put(
          "/api/usuarios/UpdatePassword",
          {
            UsuarioId: this.$store.state.usuario.idUsuario,
            OldPassword: this.oldPassword,
            NewPassword: this.newPassword,
          },
          configuracion
        )
          .then((res) => {
            this.$store.commit("setHasNotChangePassword", false);
            this.$router.push({ name: "novedades" });
          })
          .catch((err) => {
            this.snackColor = "error";
            this.snackState = true;
            this.snackText = "La contraseña anterior no coincide!";

            console.error(err.response);
          });
      } else {
        this.snackText =
          "Las contraseñas no coinciden o no cumplen con los requisitos!";
        this.snackColor = "error";
        this.snackState = true;
      }
    },
    CheckChange() {
      let header = { Authorization: "Bearer " + this.$store.state.token };
      let configuracion = { headers: header };

      Axios.get(
        `/api/usuarios/HasNotChange?userId=${this.$store.state.usuario.idUsuario}`,
        configuracion
      )
        .then((res) => {
          if (res.data) {
            this.dialog = true;
          }
        })
        .catch((err) => console.error(err));
    },
  },
};
</script>

<style>
</style>